import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Cancel';
import ViewIcon from '@material-ui/icons/Visibility';
import Typography from '@material-ui/core/Typography';
import LockIcon from '@material-ui/icons/Lock';
import CartIcon from "@material-ui/icons/ShoppingCart";
import AddToCart from './AddToCart';

import { Context as PropertyContext } from '../../context/property.context';
import { Context as AuthContext } from '../../context/auth.context';

const numberWithCommas = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};





// const columns = [
// 	{ id: 'rownumber', label: '', align: 'left' },
// 	{ id: 'ownerName', label: 'Owner Name' },
// 	{ id: 'location', label: 'Location' },
// 	{id: 'parcelNumber', label: 'Parcel Number' },
// 	{ id: 'recordType', label: 'Record Type' },
// 	{
// 		id: 'taxYear',
// 		label: 'Tax Year',
// 	},
// 	{
// 		id: 'account',
// 		label: 'Account',
// 	},
// 	{
// 		id: 'amount',
// 		label: 'Amount',
// 		align: 'right',
// 	},
// 	{
// 		id: 'cart',
// 		label: 'Add To Cart',
// 		align: 'center',
// 		minWidth: 120,
// 	},
// 	{
// 		id: 'view',
// 		label: '',
// 		align: 'center',
// 	},
// ];

const useStyles = makeStyles({
	root: {
		width: '100%',

		borderRadius: 8,
	},
	container: {
		// maxHeight: 540,
		minWidth: 650,
		borderRadius: 8,
	},
});

export default function StickyHeadTable(props) {
	const classes = useStyles();

	const { state, setPage, setRowsPerPage } =
		React.useContext(PropertyContext);
	const auth = React.useContext(AuthContext);

	const { opID } = useParams();

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const columns = [
		{ id: 'rownumber', label: '', align: 'left' },
		{ id: 'ownerName', label: 'Owner Name' },
	];
	
	//This column is only available if the merchant has enabled the coris integration
	if(auth.state.merchant.enableCoris == 1){
		columns.push(	
			{
				id: 'invoiceID',
				label: 'Case Number',
			},
			{
				id: 'account',
				label: 'Account',
			}
		);		
	} else {

		
		if(auth.state.merchant.breakdownBaseTaxInterestAndFees == 1){
			//add to the columns
			columns.push(	
				{
					id: 'taxYear',
					label: 'Tax Year',
				},{
					id: 'recordType',
					label: 'Record Type',
				},
				{
					id: 'location',
					label: 'Location',
				},
				{
					id: 'parcelNumber',
					label: 'Parcel Number',
				},
				{
					id: 'baseTax',
					label: 'Base Tax',
					align: 'right',
				},
				{
					id: 'interestAndFees',
					label: 'Interest & Fees',
					align: 'right',
				},
				{
					id: 'originalAmount',
					label: 'Amount',
					align: 'right',
				},
		
			);
		} else{

			//add to the columns
			columns.push(	
				{
					id: 'taxYear',
					label: 'Tax Year',
				},{
					id: 'recordType',
					label: 'Record Type',
				},
				{
					id: 'location',
					label: 'Location',
				},
				{
					id: 'parcelNumber',
					label: 'Parcel Number',
				},
				{
					id: 'account',
					label: 'Account',
				},
				{
					id: 'originalAmount',
					label: 'Amount',
				},
		
			);

		}



	}

	//Add the last of the default columns
	columns.push(
		{ id: 'amount', label: 'Balance', align: 'right',},
		{ id: 'cart', label: 'Add To Cart', align: 'center', minWidth: 120,},
		{ id: 'view', label: '',align: 'center',}
	);






	const columnLabel = (column) => {
		let value = column.label;
		if(column.id === 'account'){
			if(auth.state.merchant.enableCoris == 1){
				value = "Citiation Number"
			} else {
				value = auth.state.merchant.accountLabel;
			}
		} else if(column.id === 'location'){
			value = auth.state.merchant.physicalAddressLabel;
		} else if(column.id === 'parcelNumber'){
			value = auth.state.merchant.parcelLabel;
		} else if(column.id === 'ownerName'){
			value = "Name";
		} 
		
		return value;
	}

	return (
		<div style={{ width: '100%' }}>
			<Paper
				className={classes.root}
				id="fullPropertyTable"
				elevation={3}
				style={{
					boxSizing: 'border-box',
				}}
			>
				<TableContainer>
					<Table stickyHeader aria-label="sticky table">
						<TableHead style={{ background: '#ECF1F5 !important' }}>
							<TableRow style={{ background: '#ECF1F5' }}>
								{columns.map((column) => (
										<TableCell
										key={column.id}
										align={column.align}
										style={{
											minWidth: column.minWidth,
											background: '#ECF1F5',
										}}
									>
										{ columnLabel(column) }
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{state.tempTaxBills
								.slice(
									state.page * state.rowsPerPage,
									state.page * state.rowsPerPage +
										state.rowsPerPage
								)
								.map((row, index) => {
									return (
										<TableRow
											hover
											role="checkbox"
											tabIndex={-1}
											key={index}
										>
											{columns.map((column) => {


												const value = ((auth.state.merchant.enableCoris == 1 && column.id === 'account' && row.invoiceID == row.account) 
													? '' : row[column.id]);



												// if (column.id === "rownumber") {
												//   return (
												//     <TableCell key={column.id} align={column.align}>
												//       <div
												//         style={{
												//           display: "flex",
												//           flexDirection: "row",
												//           justifyContent: "center",
												//           alignItems: "center",
												//         }}
												//       >
												//         {row.row}
												//       </div>
												//     </TableCell>
												//   );
												// }

												if (
													column.id === 'baseTax' || column.id === 'interestAndFees'
												) {
													return (
														<TableCell
															key={column.id}
															align={column.align}
															style={{whiteSpace: 'pre-line'}}
														>
															${value}
														</TableCell>
													)
													
												}


												if (
													auth.state.merchant.enableCoris != 1 && column.id === 'originalAmount'
												) {
													return (
														<TableCell
															key={column.id}
															align={column.align}
														>
															<div
																style={{
																	display:'flex',
																	flexDirection:'row',
																	alignItems: 'center',
																	justifyContent:'right',
																}}
																>
																	<Typography
																		variant="body1"
																		style={{
																			fontWeight:
																				'bold',
																		}}
																	>
																		${row.amount}
																	</Typography>
															</div>
														</TableCell>
													)
												}

												if (column.id === 'amount') {
													return (														
														<TableCell
															key={column.id}
															align={column.align}
														>
															<div
																style={{
																	display:'flex',
																	flexDirection:'row',
																	alignItems: 'center',
																	justifyContent:'right',
																}}
															>

																{/* {row.paid === 1 && (
																	<CheckIcon
																		style={{
																			color: '#5AA869',
																			marginRight: 8,
																		}}
																	/>
																)} */}
																<Typography
																	variant="body1"
																	style={{
																		fontWeight:
																			'bold',
																	}}
																>
																	${numberWithCommas(row.balance.toFixed(2))}
																</Typography>

															</div>
														</TableCell>
													);
												}

												if (column.id === 'cart') {
													return (
														<TableCell
															key={column.id}
															align={column.align}
														>
															<div
																style={{
																	display:
																		'flex',
																	flexDirection:
																		'row',
																	justifyContent:
																		'center',
																	alignItems:
																		'center',
																}}
															>
																{row.paid ? (
																	<Button variant="contained"
																		startIcon={
																			<CartIcon />
																		} 
																		disabled
																	>
																		Paid
																	</Button>
																) : (	
																	<AddToCart
																		cartItem={
																			row
																		}
																	/>
																)}
															</div>
														</TableCell>
													);
												}

												if (column.id === 'view') {
													return (
														<TableCell
															key={column.id}
															align={column.align}
														>
															<Link
																to={{
																	pathname: `/${opID}/view_record/${row.invoiceID}`,
																	state: {
																		invoiceID:
																			row.invoiceID,
																		item: row,
																	},
																}}
																style={{
																	textDecoration:
																		'none',
																}}
															>
																<Button
																	variant="contained"
																	startIcon={
																		<ViewIcon />
																	}
																>
																	View
																</Button>
															</Link>
														</TableCell>
													);
												}

												return (
													<TableCell
														key={column.id}
														align={column.align}
														style={{whiteSpace: 'pre-line'}}
													>
														{column.format &&
														typeof value ===
															'number'
															? column.format(
																	value
															  )
															: value}
													</TableCell>
												);
											})}
										</TableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						alginItems: 'cneter',
						justifyContent: 'space-between',
						paddingLeft: 20,
					}}
				>
					<Typography
						variant={'1'}
						style={{ display: 'flex', alignItems: 'center' }}
					>
						Page {state.page + 1} of{' '}
						{Math.ceil(
							state.tempTaxBills.length / state.rowsPerPage
						)}
					</Typography>
					<TablePagination
						rowsPerPageOptions={[20, 50, 100]}
						component="div"
						count={state.tempTaxBills.length}
						rowsPerPage={state.rowsPerPage}
						page={state.page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
					/>
				</div>
			</Paper>
			<div id="mobilePropertyTable">
				{state.tempTaxBills.map((row, index) => {
					return (
						<Paper
							elevation={0}
							style={{
								width: '100%',
								paddingTop: 15,
								paddingBottom: 15,
								borderRadius: 0,
								display: 'flex',
								flexDirection: 'column',
								borderTop: '1px solid #ddd',
							}}
						>
							<div
								style={{
									width: '100%',
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: '100%',
									}}
								>
									<Typography variant="caption">
										Owner Name
									</Typography>
									<Typography
										variant="body1"
										style={{
											marginBottom: 8,
											fontWeight: 'bold',
										}}
									>
										{row.ownerName}
									</Typography>

									<Typography variant="caption">
										Address
									</Typography>
									<Typography
										variant="body1"
										style={{
											marginBottom: 8,
											fontWeight: 'bold',
											whiteSpace: 'pre-line'
										}}
									>
										{row.fullAddress}
									</Typography>



									<Typography variant="caption">
										{auth.state.merchant.accountLabel}
									</Typography>
									<Typography
										variant="body1"
										style={{
											marginBottom: 8,
											fontWeight: 'bold',
										}}
									>
										{row.account}
									</Typography>
									<Typography variant="caption">
										Record Type
									</Typography>
									<Typography
										variant="body1"
										style={{
											marginBottom: 8,
											fontWeight: 'bold',
										}}
									>
										{row.recordType}
									</Typography>
								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: '100%',
										alignItems: 'flex-end',
									}}
								>
									<div
										variant="body1"
										style={{
											marginBottom: 8,
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											background:
												row.paid === 1
													? '#D4EDD9'
													: '#F8D7D9',
											padding: 8,
											paddingBottom: 4,
											paddingTop: 4,
											borderRadius: 6,
										}}
									>


										{row.paid === 1 && (
											<CheckIcon
												style={{
													color: '#5AA869',
													marginRight: 8,
												}}
											/>
										)}

										<Typography
										variant="body1"
										style={{
											fontWeight:
												'bold',
										}}
										>
											${numberWithCommas(row.balance.toFixed(2))}
										</Typography>


{/* 										
										{row.paid === 1 ? (
											<CheckIcon
												style={{
													color: '#5AA869',
													marginRight: 8,
												}}
											/>
										) : (
											<ErrorIcon
												style={{
													color: '#DB575F',
													marginRight: 8,
												}}
											/>
										)}
										{row.paid === 1 ? 'Paid' : 'Unpaid'} */}
									</div>

									<Typography variant="caption">
										Tax Year
									</Typography>
									<Typography
										variant="body1"
										style={{
											marginBottom: 8,
											fontWeight: 'bold',
										}}
									>
										{row.taxYear}
									</Typography>
									<Link
										to={{
											pathname: `/${opID}/view_record/${row.invoiceID}`,
											state: {
												invoiceID: row.invoiceID,
												item: row,
											},
										}}
										style={{ textDecoration: 'none' }}
									>
										<Button
											variant="contained"
											startIcon={<ViewIcon />}
										>
											View
										</Button>
									</Link>
								</div>
							</div>

							{!row.paid ? <AddToCart cartItem={row} /> : null}
						</Paper>
					);
				})}
			</div>
		</div>
	);
}
